/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { GetAdminMarketCreatorAccessResponse, GetAdminMarketCreatorAccessVars } from '../openapi-types.gen.js';

export type { GetAdminMarketCreatorAccessResponse, GetAdminMarketCreatorAccessVars } from '../openapi-types.gen.js';

export const useGetAdminMarketCreatorAccess = createMutationHook<GetAdminMarketCreatorAccessVars, GetAdminMarketCreatorAccessResponse, unknown>({
  specName: 'useGetAdminMarketCreatorAccess',
  path: '/v1/admin/market-creations/creator-access',
  method: 'POST',
  resolveUrl: (vars: GetAdminMarketCreatorAccessVars) => `/v1/admin/market-creations/creator-access`,
  buildBody: (vars: GetAdminMarketCreatorAccessVars) => ({ proof: vars.proof, partnerCreatorId: vars.partnerCreatorId, marketType: vars.marketType }),
  parseResponse: (raw: unknown): GetAdminMarketCreatorAccessResponse => raw as GetAdminMarketCreatorAccessResponse,
  
  
  
});
